<script>
import WizardStepOne from '@/components/profile/administrationManagement/WizardStepOne.vue'
import WizardStepTwo from '@/components/profile/administrationManagement/WizardStepTwo.vue'
import WizardStepThree from '@/components/profile/administrationManagement/WizardStepThree.vue'

export default {
  components: {
    WizardStepThree,
    WizardStepTwo,
    WizardStepOne
  },
  props: {
    invitationLoading: {
      type: Boolean,
      default: false
    }
  },
  data: vm => ({
    loading: false,
    step: 1,
    csvFile: null,
    selectedMethod: 'email',
    validationResponse: null,
    validationRules: [
      value => {
        return !value || !value.length || value[0].size < 50000000
          || this.$t('component.profile.administrationManagement.csv.upload.validation.rule.error')
      }
    ],
    alert: {
      state: false,
      type: 'error',
      message: vm.$t('global.error')
    }
  }),
  methods: {
    onAlert(error) {
      console.error('alerting error', error)
      this.alert.state = true

      setTimeout(() => {
        this.alert.state = false
      }, 2500)
    },
    onFinishWizard() {
      this.$emit('finished')
      this.step = 1
    },
    onCheckedUserForDupes(user) {
      this.$emit('checked', user)
    },
    onSetCSVFile(file) {
      this.csvFile = file
    },
    onSelectingInvitationMethod(method) {
      this.selectedMethod = method
      this.step++
    },
    onSetValidationResponse(response) {
      this.validationResponse = response
    },
    onCancel() {
      // this.$refs.invitationForm.reset()
      this.alert.state = false
      this.$emit('cancel')
    }
  }
}
</script>
<template>
  <div>
    <v-card-text>

      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step step="1" :complete="step > 1">
            <!--            Methode-->
            {{ $t('global.method') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="step > 2">
            <!--            Einladung-->
            {{ $t('global.invitation') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :complete="step > 3">
            <!--            Prüfung-->
            {{ $t('global.examination') }}
          </v-stepper-step>
          <v-divider></v-divider>
        </v-stepper-header>
        <v-stepper-items>
          <!--          ALERT OUTPUT-->
          <v-alert
            v-model="alert.state"
            border="top"
            :type="alert.type"
            transition="fade-transition"
            dense
            v-html="alert.message">
          </v-alert>
          <!--          METHOD-->
          <WizardStepOne @selectingMethod="onSelectingInvitationMethod" />
          <!--          INVITATION-->
          <WizardStepTwo
            :selected-method="selectedMethod"
            @step-back="step--"
            @step-forward="step++"
            @finish-wizard="onFinishWizard"
            @set-csv-file="onSetCSVFile"
            @set-validation-response="onSetValidationResponse"
            @checked-user-for-dupes="onCheckedUserForDupes"
            @close-dialog="onCancel"
            @alert-error="onAlert" />
          <!--          CHECK-->
          <WizardStepThree
            :validation-response="validationResponse"
            :selected-method="selectedMethod"
            :csv-file="csvFile"
            @step-back="step--"
            @close-dialog="onCancel"
            @finish-wizard="onFinishWizard"
            @alert-error="onAlert" />
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
  </div>
</template>
